import { IPromise, IHttpService, IRequestShortcutConfig } from "angular";

import { ICollection } from "../models";
import { IApiTokenInfo } from "./models";
import { EnvironmentService } from "@gtmhub/env";

export class ApiTokensService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getApiTokens(): IPromise<ICollection<IApiTokenInfo>> {
    const url = this.env.getIntegrationsEndpoint("/auth0/tokens");

    return this.$http.get<ICollection<IApiTokenInfo>>(url).then((response) => response.data);
  }

  public getUserApiTokens(userId: string): IPromise<ICollection<IApiTokenInfo>> {
    const url = this.env.getIntegrationsEndpoint("/auth0/" + userId + "/tokens");

    return this.$http.get<ICollection<IApiTokenInfo>>(url).then((response) => response.data);
  }

  public createApiToken(apiToken: IApiTokenInfo): IPromise<IApiTokenInfo> {
    const url = this.env.getIntegrationsEndpoint("/auth0/" + apiToken.user.id + "/tokens");

    return this.postCreateToken(url, apiToken);
  }

  public createApplicationToken(apiToken: IApiTokenInfo): IPromise<IApiTokenInfo> {
    const url = this.env.getIntegrationsEndpoint("/auth/tokens");

    return this.postCreateToken(url, apiToken);
  }

  public revoke(apiToken: IApiTokenInfo): IPromise<unknown> {
    const url = this.env.getIntegrationsEndpoint("/auth/tokens/revoke");

    return this.$http.post(url, apiToken).then((response) => response.data);
  }

  private postCreateToken(url: string, apiToken: IApiTokenInfo): IPromise<IApiTokenInfo> {
    const gtmhubAdditionalParams: IRequestShortcutConfig = {
      params: {
        gtmhubAdditionalParams: {
          tokenType: apiToken.type,
        },
      },
    };

    return this.$http.post<IApiTokenInfo>(url, apiToken, gtmhubAdditionalParams).then((response) => response.data);
  }
}
